// Excerpts can be a blog's official Summary bullets, stored one per line with a
// leading "• ". Full views render them as a list; compact views (cards,
// roundup blurbs, digest) read them as running text.

/** The bullets, or null when the text isn't a bullet list. */
export function summaryBullets(text: string): string[] | null {
  const lines = text.split("\n").map((l) => l.trim()).filter(Boolean);
  if (lines.length < 2 || !lines.every((l) => l.startsWith("• "))) return null;
  return lines.map((l) => l.slice(2));
}

/** Plain running text: bullets joined into sentences. */
export function plainSummary(text: string): string {
  const b = summaryBullets(text);
  return b ? b.map((x) => (/[.!?]$/.test(x) ? x : `${x}.`)).join(" ") : text;
}
